<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

// Modal do sistema para pendências e falhas de WhatsApp Flows. Substitui blocos de erro
// dentro dos formulários; ao fechar, o chamador pode levar o foco ao primeiro campo inválido.
const emit = defineEmits(['close']);
const { t } = useI18n();

const dialogRef = ref(null);
const title = ref('');
const description = ref('');
const confirmLabel = ref('');
const issues = ref([]);

const toItem = issue =>
  typeof issue === 'string' ? { message: issue } : { ...issue };

const open = ({
  title: nextTitle = '',
  description: nextDescription = '',
  issues: nextIssues = [],
  confirmLabel: nextConfirmLabel = '',
} = {}) => {
  title.value = nextTitle || t('WHATSAPP_FLOWS.ISSUES.TITLE');
  description.value = nextDescription;
  confirmLabel.value = nextConfirmLabel || t('WHATSAPP_FLOWS.ISSUES.CLOSE');
  issues.value = (nextIssues || []).filter(Boolean).map(toItem);
  dialogRef.value?.open();
};

const close = () => dialogRef.value?.close();

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    width="lg"
    solid
    :title="title"
    :description="description"
    :confirm-button-label="confirmLabel"
    :show-cancel-button="false"
    @confirm="close"
    @close="emit('close')"
  >
    <ul
      class="mb-0 flex max-h-[50vh] list-none flex-col gap-2 overflow-y-auto p-0"
      role="alert"
    >
      <li
        v-for="(issue, index) in issues"
        :key="index"
        class="flex items-start gap-2 rounded-lg border border-n-weak bg-n-alpha-1 px-3 py-2 text-sm text-n-slate-12"
      >
        <span
          class="i-hugeicons-alert-circle mt-0.5 size-4 shrink-0 text-n-ruby-11"
          aria-hidden="true"
        />
        <div class="min-w-0 break-words">
          <p class="mb-0">{{ issue.message }}</p>
          <p v-if="issue.location" class="mb-0 mt-0.5 text-xs text-n-slate-11">
            {{ issue.location }}
          </p>
          <details v-if="issue.detail" class="mt-1 text-xs text-n-slate-11">
            <summary class="cursor-pointer">
              {{ t('WHATSAPP_FLOWS.ISSUES.DETAIL') }}
            </summary>
            <p class="mb-0 mt-1 font-mono">{{ issue.detail }}</p>
          </details>
        </div>
      </li>
    </ul>
  </Dialog>
</template>
